export default __webpack_public_path__ + "static/media/werking-1.e73dd26c.JPG";